import { EntidadeBase } from 'hay-core-react';
class UsuarioEquipamentoModel extends EntidadeBase {
    constructor() {
        super('usuarioequipamento');
    }
}
const instance = new UsuarioEquipamentoModel();
export default instance;
